import { Box, Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import * as ROUTES from '../../../../router/Routes';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { NameComponent } from '../../usuarios/components/ListadoUsuarios';
import {
  allUsuEntPerfilesAction,
  deleteUsuEntPerfilesAction,
  setActivoUsuEntPerfilesAction,
} from '../UsuEntPerfilesAction';
import { PARAMS_USU_PERFILES } from '../UsuEntPerfilesReducer';

export const Links = styled.a`
  cursor: pointer;
  color: black;
  margin: 0px 0px;
  text-decoration: none;

  &:hover {
    color: blue;
  }
`;

const ListadoUsuEntPerfiles = () => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const usuEntPerfilesStore = Redux.useSelector(
    (state) => state.usuEntPerfiles,
  );
  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...usuEntPerfilesStore.params,
        idUsuEntidad: usuEntidadesStore.activo.id,
        idEntidad: entidadesStore.activo.id,
      };
      dispatch({ type: PARAMS_USU_PERFILES, payload });
      await allUsuEntPerfilesAction(dispatch, payload);
    };
    return fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rowsData = [];
    usuEntPerfilesStore.all.forEach((el) =>
      rowsData.push({
        ...el,
        nombre: el.perfil.nombre,
        estatus: el.estatus,
        actions: el,
      }),
    );
    setRows(rowsData);
  }, [usuEntPerfilesStore.all]);

  const _handleEditClick = async (id) => {
    const data = usuEntPerfilesStore.all.find((el) => el.id === id);
    await setActivoUsuEntPerfilesAction(dispatch, data);
    history.push(ROUTES.permisos.to);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteUsuEntPerfilesAction(
      { dispatch, notify },
      usuEntPerfilesStore.activo.id,
      usuEntPerfilesStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '70px' }}>
              <Tooltip
                describeChild
                title="Estatus del registro"
                placement="left"
              >
                <Chip
                  label={value?.nombre}
                  size="small"
                  color={value?.id === 1 ? 'success' : 'error'}
                />
              </Tooltip>
            </Box>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '70px' }}>
              <Stack direction="row">
                <BotonComponent
                  click={async () => {
                    await setActivoUsuEntPerfilesAction(dispatch, value);
                    history.push(ROUTES.permisos.to);
                  }}
                  icon
                  size="medium"
                  transparentBg
                  dashboardIcon
                  tooltip="Panel del equipo"
                />
                <ActionsListWidget
                  id={tableMeta.rowData[0]}
                  onDelete={async () => {
                    const data = usuEntPerfilesStore.all.find(
                      (el) => el.id === tableMeta.rowData[0],
                    );
                    await setActivoUsuEntPerfilesAction(dispatch, data);
                    setOpenModalDelete(true);
                  }}
                />
              </Stack>
            </Box>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={usuEntPerfilesStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {usuEntPerfilesStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            {usuEntPerfilesStore.activo.perfil.nombre}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoUsuEntPerfiles;
